<ish-modal-dialog
  #catalogToSflModal
  data-testing-id="quote-catalog-to-sfl-modal"
  [options]="{
    size: 'md',
    centered: true,
    icon: 'exclamation-triangle-fill',
    iconClass: 'text-warning pe-2',
    titleText: ('quote.inbound.catalog_to_sfl.title' | translate),
    confirmText: ('quote.inbound.catalog_to_sfl.confirm' | translate),
    rejectText: ('quote.inbound.catalog_to_sfl.cancel' | translate),
  }"
  (confirmed)="onCatalogConfirm()"
  (closed)="onCatalogClosed()"
>
  @if (pending$ | async; as pending) {
    <p data-testing-id="quote-catalog-to-sfl-message">
      {{ 'quote.inbound.catalog_to_sfl.message' | translate: { count: itemCount(pending) } }}
    </p>
    <div class="alert alert-info mb-0" role="status">
      {{ 'quote.inbound.catalog_to_sfl.note' | translate }}
    </div>
  }
</ish-modal-dialog>

<ish-modal-dialog
  #sflBlockedModal
  data-testing-id="quote-sfl-to-cart-blocked-modal"
  [options]="{
    size: 'md',
    centered: true,
    icon: 'exclamation-triangle-fill',
    iconClass: 'text-warning pe-2',
    titleText: ('quote.inbound.sfl_to_cart_blocked.title' | translate),
    confirmText: ('quote.inbound.sfl_to_cart_blocked.confirm' | translate),
  }"
  (confirmed)="onBlockedClosed()"
  (closed)="onBlockedClosed()"
>
  <p data-testing-id="quote-sfl-to-cart-blocked-message">
    {{ 'quote.inbound.sfl_to_cart_blocked.message' | translate }}
  </p>
</ish-modal-dialog>
